export const GameStatsTableSkeleton = () => {
	return (
		<div className="max-w-screen-xl animate-pulse">
			<div className="mt-10">
				<div className="flex animate-pulse flex-col gap-4 bg-gray-200 p-6">
					<div className="h-28 w-full rounded-md bg-gray-300" />
					<div className="h-14 w-full rounded-md bg-gray-300" />
					<div className="h-14 w-full rounded-md bg-gray-300" />
					<div className="h-14 w-full rounded-md bg-gray-300" />
					<div className="h-14 w-full rounded-md bg-gray-300" />
					<div className="h-14 w-full rounded-md bg-gray-300" />
					<div className="h-14 w-full rounded-md bg-gray-300" />
				</div>
			</div>
		</div>
	);
};
